<mat-card>
  <h2 translate>request.title</h2>
  <form [formGroup]="requestDataUptakeForm">
    <div fxFlex fxLayout="row wrap" class="form-wrapper">
      <!-- <div fxFlex="50" fxFlex.gt-sm="40">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="commercialProduct"
          [id]="'commercialProductUptakeData'"
          [dataInput]="commercialProductList"
          [placeholder]="'request.commercialProduct'"
          [isRequired]="true"
          [showErrors]="requestDataUptakeForm?.controls?.commercialProduct?.errors"
          (selectionChange)="onCommercialProductSelected($event)"
        ></scf-custom-select-search>
      </div>       -->

      <div fxFlex="50" fxFlex.gt-sm="40">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="commercialProduct"
          [id]="'commercialProductUptakeData'"
          [dataInput]="commercialProductList"
          [placeholder]="'request.commercialProduct'"
          [isRequired]="true"
          [showErrors]="requestDataUptakeForm?.controls?.commercialProduct?.errors"
          (selectionChange)="onCommercialProductSelected($event); resetTariff()"
        ></scf-custom-select-search>
      </div>
      <!-- <div fxFlex="50" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.commercialProduct</mat-label>
          <mat-select
            id="commercialProductUptakeData"
            formControlName="commercialProduct"
            (selectionChange)="onCommercialProductSelected($event)"
          >
            <mat-option *ngFor="let commercialProduct of commercialProductList" [value]="commercialProduct.id">{{
              commercialProduct.value
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="requestDataUptakeForm.controls.commercialProduct.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field>
      </div> -->

      <div fxFlex="50" [fxFlex.gt-sm]="mode !== 'view' ? 25 : 30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="tariffs"
          [id]="'tariffsUptakeData'"
          [dataInput]="tariffsList"
          [placeholder]="'request.tariffs'"
          [isRequired]="true"
          [showErrors]="requestDataUptakeForm?.controls?.tariffs?.errors"
          [selectorIdProperty]="'codigo'"
          [selectorValueProperty]="'descripcion'"
        ></scf-custom-select-search>
      </div>
      <!-- <div fxFlex="50" [fxFlex.gt-sm]="showExpMonth ? 40 : 30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.tariffs</mat-label>
          <mat-select id="tariffsUptakeData" formControlName="tariffs">
            <mat-option *ngFor="let tariff of tariffsList" [value]="tariff.codigo">{{ tariff.descripcion }}</mat-option>
          </mat-select>
          <mat-error *ngIf="requestDataUptakeForm.controls.tariffs.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field> -->
      <!-- </div> -->
      <div fxFlex="50" [fxFlex.gt-sm]="!showExpMonth ? 40 : 30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.term</mat-label>
          <input
            id="termUptakeData"
            #term
            matInput
            formControlName="term"
            maxlength="3"
            (keypress)="numberOnly($event, term)"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
          <mat-error *ngIf="requestDataUptakeForm.controls.term.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field>
      </div>
      <div fxFlex="50" [fxFlex.gt-sm]="mode !== 'view' ? 25 : 30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="formPayment"
          [id]="'formPaymentUptakeData'"
          [dataInput]="formPaymentList"
          [placeholder]="'requestDataMg.paymentMode'"
          [isRequired]="true"
          [showErrors]="requestDataUptakeForm?.controls?.formPayment?.errors"
        ></scf-custom-select-search>
      </div>
      <!-- <div fxFlex="50" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataMg.paymentMode</mat-label>
          <mat-select id="formPaymentUptakeData" formControlName="formPayment">
            <mat-option *ngFor="let form of formPaymentList" [value]="form.id">{{ form.value }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->

      <!--Row-->

      <div [fxFlex]="!showExpMonth ? 100 : 50" [fxFlex.gt-sm]="!showExpMonth ? 50 : 30">
        <scf-custom-select-search
          fxFlex="100"
          formControlName="expirationDay"
          [id]="'expirationDayUptakeData'"
          [dataInput]="expirationDaysList"
          [placeholder]="'request.expireDate'"
          [isRequired]="true"
          [showErrors]="requestDataUptakeForm?.controls?.expirationDay?.errors"
        ></scf-custom-select-search>

        <!-- <div fxFlex="50" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>request.expireDate</mat-label>
          <mat-select id="expirationDayUptakeData" formControlName="expirationDay">
            <mat-option *ngFor="let expirationDay of expirationDaysList" [value]="expirationDay.id">{{
              expirationDay.value
            }}</mat-option>
          </mat-select>
          <mat-error *ngIf="requestDataUptakeForm.controls.expirationDay.hasError('required')" translate
            >field.required</mat-error
          >
        </mat-form-field> -->
      </div>

      <div fxFlex="50" *ngIf="mode == 'view'" fxFlex.gt-sm="30">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataUptake.feeAmount</mat-label>
          <input id="referenceUptakeData" matInput formControlName="share" maxlength="20" autocomplete="off" />
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.gt-sm="40" *ngIf="showExpMonth">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataUptake.expirationMonth</mat-label>
          <input
            id="expirationMonthUptakeData"
            matInput
            formControlName="expirationMonth"
            readonly
            autocomplete="off"
          />
        </mat-form-field>
      </div>

      <!-- Row -->
      <div fxFlex="50" fxFlex.gt-sm="40">
        <mat-form-field fxFlex="100" appearance="outline">
          <mat-label translate>requestDataUptake.reference</mat-label>
          <input
            id="referenceUptakeData"
            matInput
            formControlName="reference"
            [maxlength]="maxLength"
            autocomplete="off"
          />
          <mat-hint translate>request.optional</mat-hint>
        </mat-form-field>
      </div>

      <!-- end row view mode -->

      <div fxFlex="50" [fxFlex.gt-sm]="mode !== 'view' ? 25 : 30">
        <div fxFlex="100" class="request__button-calculate">
          <button
            id="calculateFinanceButtonUptakeData"
            *ngIf="mode !== 'view'"
            color="primary"
            mat-flat-button
            (click)="calculateFinance(true)"
          >
            <mat-label translate>request.buttonCalculate</mat-label>
          </button>
        </div>
      </div>
    </div>
  </form>
</mat-card>
